const createOptions = (start, end, step) => {
  const options = [];

  for (let i = start; i <= end; i += step) {
    options.push({
      label: i.toString(),
      value: i.toString(),
    });
  }

  return options.toReversed();
};

export const YEAR_OPTIONS = [
  ...createOptions(1970, 2030, 1),
];

export const MONTHS_OPTIONS = [
  {value: 1, label: 'January'},
  {value: 2, label: 'February'},
  {value: 3, label: 'March'},
  {value: 4, label: 'April'},
  {value: 5, label: 'May'},
  {value: 6, label: 'June'},
  {value: 7, label: 'July'},
  {value: 8, label: 'August'},
  {value: 9, label: 'September'},
  {value: 10, label: 'October'},
  {value: 11, label: 'November'},
  {value: 12, label: 'December'},
];

export const US_AUTH_OPTIONS = [
  {
    label: 'Yes, Permanently.',
    help: 'I have permanent authorization (e.g., US citizen, permanent resident, or similar)',
    value: 'permanent',
    bold: true,
  },
  {
    label: 'Yes, Presently.',
    help: 'I have current work authorization for a defined time period (e.g., Visa, including temporary visas)',
    value: 'present',
    bold: true,
  },
  {
    label: 'Expected / In-Process.',
    help: 'I do not have current US work authorization but have applied for resident status, visas or other work authorization, expect to receive a TN Visa, or my application is in process.',
    value: 'expected',
    bold: true,
  },
  {
    label: 'No / Unclear.',
    help: 'I need Visa sponsorship now or in the near future or am unclear about my current status.',
    value: 'no',
    bold: true,
  },
  {label: 'Other (please explain).', value: 'other', bold: true},
];

export const GENDER_OPTIONS = [
  {label: 'Woman', value: 'woman'},
  {label: 'Man', value: 'man'},
  {label: 'Non-binary / Other', value: 'other'},
];

export const RACE_OPTIONS = [
  {label: 'Black or African American', value: 'black'},
  {label: 'Hispanic or Latino', value: 'latino'},
  {label: 'Asian (incl. East Asian, Southeast Asian, and South Asian/Indian)', value: 'asian'},
  {label: 'Native American or Alaska Native', value: 'american'},
  {label: 'Native Hawaiian or Other Pacific Islander', value: 'hawaiian'},
  {label: 'Middle Eastern or North African', value: 'arfican'},
  {label: 'White or Caucasian', value: 'white'},
  {label: 'Other', value: 'other'},
];

export const LGBTQ_OPTIONS = [
  {label: 'Yes - I identify as LGBTQ+', value: 'yes'},
  {label: 'No - I do not', value: 'no'},
];

export const MILITARY_OPTIONS = [
  {label: 'Yes – I am currently serving or have served in the U.S. military', value: 'us_military'},
  {label: 'Yes – I am currently serving or have served in the military of another country', value: 'military'},
  {label: 'No - I have not served in the military', value: 'no_military'},
];

export const DISCLOSE_OPTIONS = [
  {label: 'Prefer not to disclose', value: 'prefer_not_to_say'},
  {
    label: 'OK to disclose to employers and for DEI initiatives',
    value: 'ok_to_say'
  },
];

export const DISCLOSE_OPTIONS_ALT = [
  {label: 'Prefer not to disclose', value: 'prefer_not_to_say'},
  {
    label: 'OK to disclose to employers',
    value: 'ok_to_say'
  },
];

export const SPORTS_OPTIONS = [
  {label: 'No – Informal sports / intramurals or prefer not to disclose', value: 'No'},
  {label: 'Yes – Club sports', value: 'Club'},
  {label: 'Yes – Varsity sports', value: 'Varsity'},
];
